var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriceAlert = function SvgPriceAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 16.667a1.667 1.667 0 0 1-3.334 0zm0-13.924a5.835 5.835 0 0 1 4.166 5.59v5l1.667 1.25v1.25h-15v-1.25l1.667-1.25v-5a5.835 5.835 0 0 1 4.166-5.59V1.667h3.334zm-.774 6.586L8.67 8.219l-1.812 2.173 1.282 1.067.964-1.16 2.224 1.112 1.812-2.174-1.282-1.067z"
  })));
};
export default SvgPriceAlert;